import formattedTimestamp from '@app/application/layout/behaviours/formatted-timestamp'

const setupTimestamps = () => {
  document.addEventListener('render_async_load', function (event) {
    formattedTimestamp(event.container)
    event.container
      .querySelectorAll('[data-toggle="tooltip"]')
      .forEach((element) =>
        $(element).trigger('tooltipsRendered', element.parentElement)
      )
  })
}
export default setupTimestamps
